const PI_AID = "281622";
const PI_CID = "1470";
const PI_HOSTNAME = "pi.pardot.com";
const PI_SCRIPT_URL = ".pardot.com/pd.js";
const inject = () => {
  const isNotLoaded = typeof window.piAId === "undefined" || typeof window.piCId === "undefined" || typeof window.piHostname === "undefined";
  if (isNotLoaded) {
    window.piAId = PI_AID;
    window.piCId = PI_CID;
    window.piHostname = PI_HOSTNAME;
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = ("https:" == document.location.protocol ? "https://pi" : "http://cdn") + PI_SCRIPT_URL;
    document.head.appendChild(script);
  }
};

export { inject };
//# sourceMappingURL=b2x-pardot.esm.js.map
